import { render, staticRenderFns } from "./KedvezmenyekB10.vue?vue&type=template&id=bef82602&"
import script from "./KedvezmenyekB10.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyekB10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports